import { createApi } from "@reduxjs/toolkit/query/react";
import {
  BASE_URL,
  GET_CUST_COMMN,
  UPDATE_SAVE_OTHERDETAIL_DATA,
  CUSTOMER_OTHER_DETAILS,
  CUSTMOER_NOTES_DATA_GET,
  CUSTOMER_REPORTING_DATA_GET,
  CUSTOMER_ADDRESS_DATA_GET,
  CUSTMOER_ARTIFACT_DATA_GET,
  CUSTOMER_SERVICE_DATA_GET,
  CUSTOMER_CONTACT_DATA_GET,
  CUSTOMER_SOCIAL_DATA_GET,
  CUSTOMER_TASK_CATEGORY,
  CUSTOMER_TASK_DATA_GET,
  CUSTOMER_NOTES_COLOR_CODE,
  CUSTOMER_MANAGER_LIST,
  CUSTOMER_ARTIFACT_DATATYPE,
  CUSTOMER_DETAILS_DATA,
  CUSTOMER_DESINATION_LIST,
  CUSTOMER_GET_USER_DATA,
  CUSTOMER_TASK_POD_DATA,
  TASK_VIEW_DATA,
  CUSTOMER_SERVICE_CATEGORY,
  CUSTOMER_SOCIAL_CATEGORY,
  GET_COMPANY_DEFAULT_ADDRESS,
  GET_VENDOR_DEFAULT_ADDRESS,
  CUSTOMER_DEPARTMENT_LIST,
  VENDOR_HEADER_LIST,
  CUSTOMER_TASK_PROJECT_CATEGORY,
  CUSTOMER_ACTIVITY_GET_EVENT,
  CUSTOMER_ACTIVITY_ADD_EVENT,
  ADD_UPDATE_TEAM_MEMBER,
  CREATE_UPDATE_PROJECTS,
  CUSTOMER_ADD_TEAM,
  CUSTOMER_TEAM_ROLES,
  CUSTOMER_TEAM_SKILLS_LEVEL,
  CUSTOMER_TEAM_SKILL_LEVELS,
  CUSTOMER_TEAM_ALL_GET_DATA,
  CUSTOMER_COMMON_DATA,
  NODE_URL,
  GET_ALL_SECTIONS,
  GET_SECTION_FILEDS,
  GET_FIELD_VALUE,
  GET_ALL_TEMPLATE,
  GET_ALL_LINKED_SECTIONS,
  DELETE_LINKED_SECTION,
  GET_LINKED_SECTIONS_FIELDS,
  GET_ALL_TASKS,
  DELETE_SECTION,
  DELETE_TEMPLATE,
  DELETE_FIELD,
  GET_SECTIONANDFIELDS,
  GET_SECTION_AND_FIELDS,
  GET_NOTES_TAGS,
} from "../constants";
import { query } from "@firebase/firestore";
import customBaseQuery from "../CustomBaseQuery/customBaseQuery";
import { getCompanyId, getUserToken } from "../utilityFunctions/localServices";

export const customerServiceCategoryApi = createApi({
  reducerPath: "customerServiceCategoryApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchServiceCategory: builder.query({
      query: ({ token }) => ({
        url: CUSTOMER_SERVICE_CATEGORY,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    fetchSocialCategory: builder.query({
      query: ({ token }) => ({
        url: CUSTOMER_SOCIAL_CATEGORY,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    fetchCustomerDesignation: builder.query({
      query: ({ token }) => ({
        url: CUSTOMER_DESINATION_LIST,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),

    fetchCustomerCommn: builder.query({
      query: (token) => ({
        url: GET_CUST_COMMN,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    updateSaveOtherDetail: builder.mutation({
      query: ({ token, data }) => ({
        url: UPDATE_SAVE_OTHERDETAIL_DATA, // Replace with your endpoint
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
    fetchCustomerEdit: builder.query({
      query: ({ token, customerId }) => {
        return {
          url: `${CUSTOMER_OTHER_DETAILS}${customerId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          providesTags: ["CustomerOtherDetailData"],
        };
      },
    }),

    fetchCustomerNotesData: builder.query({
      query: ({ token, trimmedCustomerId }) => {
        return {
          url: `${CUSTMOER_NOTES_DATA_GET}${trimmedCustomerId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerTeamsData: builder.query({
      query: ({ token, customerId }) => {
        return {
          url: `${CUSTOMER_REPORTING_DATA_GET}${customerId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerAddressData: builder.query({
      query: ({ token, customerId }) => {
        return {
          url: `${CUSTOMER_ADDRESS_DATA_GET}${customerId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerArtiFactData: builder.query({
      query: ({ token, customerId }) => {
        return {
          url: `${CUSTMOER_ARTIFACT_DATA_GET}${customerId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerServicesData: builder.query({
      query: ({ token, customerId }) => {
        return {
          url: `${CUSTOMER_SERVICE_DATA_GET}${customerId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerContactPersonData: builder.query({
      query: ({ token, customerId }) => {
        return {
          url: `${CUSTOMER_CONTACT_DATA_GET}${customerId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerSocialLinkData: builder.query({
      query: ({ token, customerId }) => {
        return {
          url: `${CUSTOMER_SOCIAL_DATA_GET}${customerId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
      providesTags: (result, error, arg) => [{ type: "CustomerSocial", id: arg.customerId }],
    }),

    updateCustomerSocialLinkData: builder.mutation({
      query: ({ token, data, customerId }) => {
        const payload = { token, ...data };
        return {
          url: `${CUSTOMER_SOCIAL_DATA_GET}${customerId}`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: payload,
        };
      },
      invalidatesTags: [{ type: "CustomerSocial" }],
    }),

    fetchCustomerReportingTeamsData: builder.query({
      query: ({ token, customerId }) => {
        return {
          url: `${CUSTOMER_REPORTING_DATA_GET}${customerId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchTaskData: builder.query({
      query: ({ token, jsonData }) => {
        const queryParams = new URLSearchParams(jsonData).toString();
        return {
          url: `${CUSTOMER_TASK_CATEGORY}?${queryParams}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCommonData: builder.query({
      query: () => {
        // const queryParams = new URLSearchParams(jsonData).toString();
        return {
          url: `${CUSTOMER_COMMON_DATA}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    createUpdateProjects: builder.mutation({
      query: ({ payload }) => {
        return {
          url: `${CREATE_UPDATE_PROJECTS}`,
          method: "POST",
          body: payload,
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchTasksTableData: builder.query({
      query: ({ token, jsonData }) => {
        const queryParams = new URLSearchParams(jsonData).toString();
        return {
          url: `${CUSTOMER_TASK_DATA_GET}?${queryParams}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerGetOtherDetailData: builder.query({
      query: ({ token, customerId }) => {
        return {
          url: `${CUSTOMER_OTHER_DETAILS}${customerId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerNotesColorData: builder.query({
      query: ({ token }) => {
        return {
          url: `${CUSTOMER_NOTES_COLOR_CODE}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerManagerListData: builder.query({
      query: ({ token }) => {
        return {
          url: `${CUSTOMER_MANAGER_LIST}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerArtiFactDataList: builder.query({
      query: ({ token }) => {
        return {
          url: `${CUSTOMER_ARTIFACT_DATATYPE}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerAddressDataBasedOnId: builder.query({
      query: ({ token, customerId }) => {
        return {
          url: `${CUSTOMER_DETAILS_DATA}${customerId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerGroupList: builder.query({
      query: ({ userToken }) => {
        return {
          url: `${CUSTOMER_DETAILS_DATA}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerUseListData: builder.query({
      query: ({ token }) => {
        return {
          url: `${CUSTOMER_GET_USER_DATA}/${getCompanyId()}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
      keepUnusedDataFor: 0, // Disables caching
      refetchOnMountOrArgChange: true,
    }),

    // can Delete Not in Use
    fetchCustomerTaskPodData: builder.query({
      query: ({ tokens, companyId, data }) => {
        return {
          url: `${CUSTOMER_TASK_POD_DATA}?company_id=${companyId?.company_id}`,
          method: "GET",
          body: data,
          headers: {
            Authorization: `Bearer ${tokens}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    getVendorHeaderList: builder.query({
      query: ({ tokens, companyId }) => {
        return {
          // url: `${VENDOR_HEADER_LIST}?company_id=${companyId?.company_id}`,
          url: `${VENDOR_HEADER_LIST}/types`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokens}`,
            "Content-Type": "application/json",
          },
        };
      },
      refechOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),

    getFieldsValue: builder.query({
      query: ({ tokens, voucherId }) => {
        return {
          // url: `${VENDOR_HEADER_LIST}?company_id=${companyId?.company_id}`,
          url: `${VENDOR_HEADER_LIST}/fields?voucher_type_id=${voucherId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokens}`,
            "Content-Type": "application/json",
          },
        };
      },
      refechOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),

    getOptions: builder.mutation({
      query: ({ payload, tokens }) => {
        console.log("apiMetaData 2", payload, tokens);
        return {
          // url: `${VENDOR_HEADER_LIST}?company_id=${companyId?.company_id}`,
          url: `https://nodedata.unizooks.com/v1/accounts/api/options`,
          method: "POST",
          body: payload,
          headers: {
            Authorization: `Bearer ${tokens}`,
            "Content-Type": "application/json",
          },
        };
      },
      refechOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),

    createVoucher: builder.mutation({
      query: ({ payload, tokens }) => {
        return {
          url: `${VENDOR_HEADER_LIST}/create`,
          method: "POST",
          body: payload,
          headers: {
            Authorization: `Bearer ${tokens}`,
            "Content-Type": "application/json",
          },
        };
      },
      refechOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),

    editTag: builder.mutation({
      query: ({ payload, tokens }) => {
        return {
          url: `https://nodedata.unizooks.com/v1/accounts/tags/update`,
          method: "POST",
          body: payload,
          headers: {
            Authorization: `Bearer ${tokens}`,
            "Content-Type": "application/json",
          },
        };
      },
      refechOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),

    fetchEditTask: builder.query({
      query: ({ token, taskid }) => {
        return {
          url: `${TASK_VIEW_DATA}${taskid}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerAllTaskPodData: builder.query({
      query: ({ token, company }) => {
        return {
          url: `${CUSTOMER_TASK_POD_DATA}?company_id=${company?.company_id}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCompanyAddressData: builder.query({
      query: ({ token, companyId }) => {
        return {
          url: `${GET_COMPANY_DEFAULT_ADDRESS}${companyId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchVendorDefaultAddress: builder.query({
      query: ({ token, vendorId }) => {
        return {
          url: `${GET_VENDOR_DEFAULT_ADDRESS}${vendorId}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCustomerDepartment: builder.query({
      query: ({ token }) => ({
        url: CUSTOMER_DEPARTMENT_LIST,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
    }),

    fetchCustomerActivity: builder.query({
      query: ({ token, activityid, type }) => ({
        url: `${CUSTOMER_ACTIVITY_GET_EVENT}?id=${activityid}&type=${type}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }),
      refetchOnMountOrArgChange: true,
    }),

    postCustomerActivity: builder.mutation({
      query: ({ token, data }) => ({
        url: CUSTOMER_ACTIVITY_ADD_EVENT,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),

    postCustomerAddTeam: builder.mutation({
      query: (data) => ({
        url: CUSTOMER_ADD_TEAM,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),

    postCustomerTeamRoles: builder.mutation({
      query: ({ data }) => ({
        url: CUSTOMER_TEAM_ROLES,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),

    postCustomerTeamSkillLevels: builder.mutation({
      query: ({ data }) => ({
        url: CUSTOMER_TEAM_SKILL_LEVELS,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),

    postAddTeamMember: builder.mutation({
      query: ({ data }) => ({
        url: ADD_UPDATE_TEAM_MEMBER,
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),

    fetchTeamAllData: builder.query({
      query: ({ key, customer_id }) => ({
        url: `${CUSTOMER_TEAM_ALL_GET_DATA}?key=${key}&customer_id=${customer_id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),

    fetchAllSections: builder.query({
      query: () => ({
        url: `${GET_ALL_SECTIONS}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    fetchSectionFields: builder.query({
      query: ({ sectionId }) => ({
        url: `${GET_SECTION_FILEDS}/${sectionId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    fetchNoteTags: builder.query({
      query: () => ({
        url: `${GET_NOTES_TAGS}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    fetchFieldValues: builder.query({
      query: ({ FieldName }) => ({
        url: `${GET_FIELD_VALUE}${FieldName}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    fetchAllTemplate: builder.query({
      query: (arg) => {
        const myAct = arg?.myActivities;

        // Build the URL dynamically based on myActivities value
        const url =
          myAct !== null && myAct !== undefined && myAct !== ""
            ? `${GET_ALL_TEMPLATE}?my-activities=${myAct}`
            : `${GET_ALL_TEMPLATE}`;

        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchLinkedSections: builder.query({
      query: ({ TemplateId }) => ({
        url: `${GET_ALL_LINKED_SECTIONS}/${TemplateId}/sections`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    DeleteLinkedSection: builder.mutation({
      query: ({ TemplateId, SectionId }) => ({
        url: `${DELETE_LINKED_SECTION}/${TemplateId}/${SectionId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    fetchLinkedSectionsFields: builder.query({
      query: ({ TemplateId, IsForm, template_id, is_company_level, is_compact_view }) => {
        const compactParam = is_compact_view ? `&is_compact_view=${is_compact_view}` : "";

        const baseUrl = template_id
          ? `${GET_LINKED_SECTIONS_FIELDS}/${TemplateId}?is_form=${IsForm}&is_template_id=true`
          : `${GET_LINKED_SECTIONS_FIELDS}/${TemplateId}?is_form=${IsForm}&is_company_level=${is_company_level}`;

        return {
          url: `${baseUrl}${compactParam}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchAllTasks: builder.query({
      query: ({
        taskTemplateId,
        template_id,
        is_kanban,
        visibility_status,
        quiFilter,
        customer_id,
        isPagination,
        moduleId,
        rowId,
        filter_status,
        Filter,
      }) => {
        let url = `${GET_ALL_TASKS}/${taskTemplateId}`; //normal task get request

        // Add query parameters dynamically
        const queryParams = [];
        if (template_id) {
          queryParams.push(`template_id=${template_id}`); //row base task
        }
        if (is_kanban || Filter) {
          queryParams.push(`is_kanban=${is_kanban}&customer_id=${customer_id}&quick_filter_type=${Filter}`);
        }
        if (visibility_status || quiFilter || filter_status) {
          queryParams.push(
            `visibility_status=${visibility_status}&quick_filter_type=${quiFilter}&customer_id=${customer_id}&filter_status=${filter_status}`
          );
        }
        if (isPagination) {
          queryParams.push(`pagination=20&page=1&customer_id=${customer_id}`);
        }

        if (moduleId) {
          queryParams.push(`template_id=${moduleId}`);
        }
        if (rowId) {
          queryParams.push(`row_id=${rowId}`);
        }

        // Append query parameters to the URL
        if (queryParams.length > 0) {
          url += `?${queryParams.join("&")}`;
        } else {
          url += ``;
        }

        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
    DeleteSection: builder.mutation({
      query: ({ SectionId }) => ({
        url: `${DELETE_SECTION}/${SectionId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    DeleteTemplate: builder.mutation({
      query: ({ TemplateId }) => ({
        url: `${DELETE_TEMPLATE}/${TemplateId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    DeleteField: builder.mutation({
      query: ({ field_value }) => ({
        url: `${DELETE_FIELD}/${field_value}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
    FetchSectionAndFields: builder.query({
      query: ({ TemplateId }) => ({
        url: `${GET_SECTION_AND_FIELDS}/${TemplateId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useFetchServiceCategoryQuery,
  useLazyFetchServiceCategoryQuery,
  useFetchSocialCategoryQuery,
  useLazyFetchSocialCategoryQuery,
  useFetchCustomerDesignationQuery,
  useLazyFetchCustomerDesignationQuery,
  useFetchCustomerCommnQuery,
  useLazyFetchCustomerCommnQuery,
  useUpdateSaveOtherDetailMutation,
  useFetchCustomerEditQuery,
  useLazyFetchCustomerEditQuery,
  useFetchCustomerNotesDataQuery,
  useLazyFetchCustomerNotesDataQuery,
  useFetchCustomerTeamsDataQuery,
  useLazyFetchCustomerTeamsDataQuery,
  useFetchCustomerAddressDataQuery,
  useLazyFetchCustomerAddressDataQuery,
  useFetchCustomerArtiFactDataQuery,
  useLazyFetchCustomerArtiFactDataQuery,
  useFetchCustomerServicesDataQuery,
  useLazyFetchCustomerServicesDataQuery,
  useFetchCustomerContactPersonDataQuery,
  useLazyFetchCustomerContactPersonDataQuery,
  useFetchCustomerSocialLinkDataQuery,
  useLazyFetchCustomerSocialLinkDataQuery,
  useUpdateCustomerSocialLinkDataMutation,
  useFetchCustomerReportingTeamsDataQuery,
  useLazyFetchCustomerReportingTeamsDataQuery,
  useFetchTaskDataQuery,
  useLazyFetchTaskDataQuery,
  useCreateUpdateProjectsMutation,
  useFetchCommonDataQuery,
  useFetchTasksTableDataQuery,
  useLazyFetchTasksTableDataQuery,
  useFetchCustomerGetOtherDetailDataQuery,
  useLazyFetchCustomerGetOtherDetailDataQuery,
  useFetchCustomerNotesColorDataQuery,
  useLazyFetchCustomerNotesColorDataQuery,
  useFetchCustomerManagerListDataQuery,
  useLazyFetchCustomerManagerListDataQuery,
  useFetchCustomerArtiFactDataListQuery,
  useLazyFetchCustomerArtiFactDataListQuery,
  useFetchCustomerAddressDataBasedOnIdQuery,
  useLazyFetchCustomerAddressDataBasedOnIdQuery,
  useFetchCustomerGroupListQuery,
  useLazyFetchCustomerGroupListQuery,
  useFetchCustomerUseListDataQuery,
  useLazyFetchCustomerUseListDataQuery,
  useFetchCustomerTaskPodDataQuery,
  useLazyFetchCustomerTaskPodDataQuery,
  useGetVendorHeaderListQuery,
  useLazyGetVendorHeaderListQuery,
  useGetFieldsValueQuery,
  useLazyGetFieldsValueQuery,
  useGetOptionsMutation,
  useCreateVoucherMutation,
  useEditTagMutation,
  useFetchEditTaskQuery,
  useLazyFetchEditTaskQuery,
  useFetchCustomerAllTaskPodDataQuery,
  useLazyFetchCustomerAllTaskPodDataQuery,
  useFetchCompanyAddressDataQuery,
  useFetchVendorDefaultAddressQuery,
  useFetchCustomerDepartmentQuery,
  useFetchCustomerActivityQuery,
  usePostCustomerActivityMutation,
  usePostCustomerAddTeamMutation,
  usePostCustomerTeamRolesMutation,
  usePostCustomerTeamSkillLevelsMutation,
  usePostAddTeamMemberMutation,
  useFetchTeamAllDataQuery,
  useFetchAllSectionsQuery,
  useLazyFetchSectionFieldsQuery,
  useLazyFetchFieldValuesQuery,
  useFetchAllTemplateQuery,
  useLazyFetchLinkedSectionsQuery,
  useDeleteLinkedSectionMutation,
  useLazyFetchLinkedSectionsFieldsQuery,
  useLazyFetchAllTasksQuery,
  useDeleteSectionMutation,
  useDeleteTemplateMutation,
  useDeleteFieldMutation,
  useLazyFetchSectionAndFieldsQuery,
  useFetchNoteTagsQuery,
} = customerServiceCategoryApi;

// Vendor Header List

//customer Task Activity vinay

// export const { useFetchcustomerActivityQuery, usePostcustomerActivityMutation } = customerActivityApi;
